export const isFalse = (boolean: boolean): boolean is false => !boolean
